module.exports = __webpack_public_path__ + "static/img/checked-dislike-icon.01d74cda.png";